import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { ReasignacionPcfViewModel, TInspeccionExViewModel, TwSolicitudFrExViewModel } from './inspeccionesEx.types';
import { SolicitudProductosExViewModel } from '../productos/productosEx.types';
import { TInterValoHoraPuntoInspeccionViewModel } from '../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.types';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core


@Injectable()
export class InspeccionesExService {    

    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {

    }
    
    getInspeccionEx(id: number): Observable<TInspeccionExViewModel> {
        return this.http
            .get<TInspeccionExViewModel>(this.baseUrl + 'api/exportacion/inspeccionesEx/' + id).pipe();
    }

    getEquipamientosEx(id: number): Observable<SolicitudProductosExViewModel> {
        return this.http
            .get<SolicitudProductosExViewModel>(this.baseUrl + 'api/exportacion/inspeccionesEx/EquipamientosEx/' + id).pipe();
    }

    getFr(id: number): Observable<TwSolicitudFrExViewModel[]> {
        return this.http
            .get<TwSolicitudFrExViewModel[]>(this.baseUrl + 'api/exportacion/inspeccionesEx/fr/' + id).pipe();
    }

    createInspeccionEx(inspeccionEx: TInspeccionExViewModel): Observable<any> {
        return this.http
            .post<TInspeccionExViewModel>(this.baseUrl + 'api/exportacion/inspeccionesEx', inspeccionEx).pipe();
    }

    editInspeccionEx(inspeccionEx: TInspeccionExViewModel): Observable<any> {
        return this.http
            .put<TInspeccionExViewModel>(this.baseUrl + 'api/exportacion/inspeccionesEx', inspeccionEx).pipe();
    }

    revisionSolicitante(params: HttpParams): Observable<any> {
        return this.http
            .get<any>(this.baseUrl + 'api/exportacion/inspeccionesEx/RevisionSolicitante/', { params: params }).pipe();
    }

    aplicaDocumentacion(id: number): Observable<boolean> {
        return this.http
            .get<boolean>(this.baseUrl + 'api/exportacion/inspeccionesEx/aplicaDocumentacion/' + id);
    }

    aplicaDocumentacionUk(id: number): Observable<boolean> {
        return this.http
            .get<boolean>(this.baseUrl + 'api/exportacion/inspeccionesEx/aplicaDocumentacionUk/' + id);
    }

    tieneReasignacionManual(idSolicitudEx: number): Observable<boolean> {
        return this.http
            .get<boolean>(this.baseUrl + 'api/exportacion/inspeccionesEx/tieneReasignacionManual/' + idSolicitudEx);
    }

    //Controlador reasignacion
    crearReasignacionPcf(model: ReasignacionPcfViewModel): Observable<any> {
        return this.http
            .post<ReasignacionPcfViewModel>(this.baseUrl + 'api/exportacion/inspeccionesEx/crearReasignacionPcf', model);
    }

    getIntervalosHora(idPuntoInspeccion: number): Observable<TInterValoHoraPuntoInspeccionViewModel[]> {
        return this.http.
            get<TInterValoHoraPuntoInspeccionViewModel[]>(this.baseUrl + 'api/core/global/intervalosHora/' + idPuntoInspeccion);
    }

    getUltimaReasignacionPcf(idSolicitudEx: number): Observable<ReasignacionPcfViewModel> {
        return this.http
            .get<ReasignacionPcfViewModel>(this.baseUrl + 'api/exportacion/inspeccionesEx/ultimaReasignacionPcf/' + idSolicitudEx);
    }


    //getPuntoInspeccionNuevaSolicitud(params: HttpParams): Observable<Tc[]> {
    //    return this.http
    //        .get<Tc[]>(this.baseUrl + 'api/core/global/puntosinspeccionnuevasolicitud/', { params: params }).pipe();
    //}

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    
}
